import React from "react";

import { useQuery } from "@apollo/client";
import { makeStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";

import RbCheckboxGroupField from "components/RbCheckboxGroupField";
import FieldsProvider from "fields/components/FieldsProvider";
import { productCategoryListQuery } from "graphql/productCategory";

const useStyles = makeStyles({
  root: {
    padding: 20,
  },
});

function ProductsFilter(props) {
  const { filters, onFilter } = props;

  const classes = useStyles();

  const { data: { productCategoryList = [] } = {} } = useQuery(
    productCategoryListQuery
  );

  const handleChange = (updater) => {
    const next = updater({ values: filters });
    if (next.values !== filters) {
      onFilter(next.values);
    }
  };

  const options = productCategoryList.map((pc) => ({
    value: pc.id,
    label: pc.name,
  }));

  return (
    <div className={classes.root}>
      <FieldsProvider fields={{ values: filters }} onChange={handleChange}>
        <RbCheckboxGroupField
          label={
            <Typography variant="h6" paragraph>
              Categories
            </Typography>
          }
          fieldName="categories.every"
          options={options}
        />
      </FieldsProvider>
    </div>
  );
}

ProductsFilter.propTypes = {
  filters: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
};

ProductsFilter.defaultProps = {};

export default React.memo(ProductsFilter);
